<template>
    <div>
        <h1>Plans</h1>
        <router-link to="/admin/planCreate">{{ $t("admin.adminPlanList.link.create") }}</router-link><br/><br/>

        <VueJsonToCsv :json-data="this.reportData" :labels="labels" :csv-title="this.filename">
            <label for="report">{{ $t("admin.adminPlanList.report.header") }}: </label>
            <input type="button" class="submit" v-bind:value="$t('admin.adminPlanList.report.button')" @click=csvDownload>
        </VueJsonToCsv>

        <form id="search" @submit="planSearch">
            <label for="searchTerm">{{ $t("admin.adminPlanList.search") }}: </label>
            <input id="searchTerm" name="searchTerm" v-model="searchTerm"><br/>

            <input type="submit" class="submit" v-bind:value="$t('admin.adminPlanList.button.search')">
        </form>

        <table v-if="planList" class="datatable">
            <caption class="caption">Plan list table</caption>
            <tr>
                <th scope="col">{{ $t("admin.adminPlanList.table.name") }}</th>
                <th scope="col">{{ $t("admin.adminPlanList.table.enabled") }}</th>
            </tr>
            <tr v-for="(plan, index) in planList" v-bind:key="index">
                <td><router-link :to="'/admin/planView/' + plan.id">{{ plan.name }}</router-link></td>
                <td>{{ plan.enabled ? $t("common.yes") : $t("common.no") }}</td>
            </tr>
        </table>
    </div>
</template>

<script>
    import { adminService } from '@/services/admin.service'
    import VueJsonToCsv from "vue-json-to-csv"
    import moment from 'moment'

    export default {
        name: 'AdminPlanList',
        components: {
            VueJsonToCsv
        },
        data: function() {
            return { 
                planList: [], searchTerm: "",
                reportData: [],
                labels: {
                    name: { title: 'Plan' },
                    enabled: { title: 'Enabled' },
                    eventTimestamp: { title: 'Date' },
                    userName: { title: 'User' },
                    modification: { title: 'Credits' },
                    type: { title: 'Type' },
                    reason: { title: 'Reason' }
                },
                filename: ""
            }
        },
        created: function() {
            this.planSearch(null);
            this.csvDownload(null);
        },
        methods: {
            planSearch: function (event) {
                adminService.planSearch(this.searchTerm).then((data) => {
                    this.planList = data;
                }).catch((err) => {
                    console.error('Unable to search plan: ', err)
                });
                if (event) {
                    event.preventDefault()
                }
            },
            csvDownload: async function () {
                return await new Promise(async (resolve) => {
                    let allPlanList = []
                    let allPlanListMod = {}

                    let now = new Date()
                    this.filename = 'credit_report_' + moment(now).format('YYYYMMDD_HHmmss')

                    await adminService.planSearch(null).then((data) => {
                        allPlanList = data;
                        for(let pl of allPlanList){
                            allPlanListMod[pl.meterExternalId] = {'name': pl.name, 'enabled': pl.enabled};
                        };
                    });
                    await adminService.meterEventsForReport().then((data) => {
                        this.reportData.splice(0, this.reportData.length)
                        for(let d of data){
                            let report = allPlanListMod[d.externalId]
                            if(report){
                                this.reportData.push({
                                    name: report.name,
                                    enabled: report.enabled,
                                    eventTimestamp: moment(d.eventTimestamp).format('YYYY/MM/DD HH:mm:ss'),
                                    userName: d.userName,
                                    reason: d.reason,
                                    type: d.type,
                                    modification: d.modification,
                                })
                            }else{
                                continue;
                            }
                        };
                    });
                    resolve();
                    }).catch((err) => {
                        console.error('Unable to get creidt report: ', err)
                    });
            }
        }
    }
</script> 
